import React from 'react';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import {Button, makeStyles} from '@material-ui/core';

const useStyle = makeStyles(() => ({
  button: {
    float: "right",
    marginBottom: 10,
    marginTop: 10,
  }
}))

function BackButton({handleBackNavigation}) {
  const classes = useStyle();

  return (
    <>
      <Button
        className={classes.button}
        onClick={() => {handleBackNavigation()}}
        startIcon={<ArrowBackIcon color="primary"/>}>
        Indietro
      </Button>
    </>
  );
}

export default BackButton;